"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

/**
 * FilterProcessor
 *
 * Will take a given bitmap from a layer and apply a filter to it.
 * This class is a no-op and it is expected it would be extended.
 */
var FilterProcessor = /*#__PURE__*/function () {
  function FilterProcessor() {
    (0, _classCallCheck2["default"])(this, FilterProcessor);
  }

  (0, _createClass2["default"])(FilterProcessor, [{
    key: "applyFilters",

    /**
     *
     * @param {Canvas|Image|ImageBitmap} layerBitmap
     * @param {Rectangle} bitmapDimensions
     * @param {CanvasRenderingContext2D} canvasContext
     * @param {Filters} filters
     * @param {Rectangle} safeOutputDimensions
     *
     * @returns {Canvas|Image|ImageBitmap}
     */
    value: function applyFilters(layerId, layerBitmap, bitmapDimensions, canvasContext, filters, safeOutputDimensions) {
      return layerBitmap;
    }
    /**
     *
     * @param {Object} inValue
     * @returns {boolean}
     */

  }], [{
    key: "isFilterProcessor",
    value: function isFilterProcessor(inValue) {
      return inValue instanceof FilterProcessor;
    }
  }]);
  return FilterProcessor;
}();

exports["default"] = FilterProcessor;